import { render } from "./NestedPie.vue?vue&type=template&id=61273c46&scoped=true"
import script from "./NestedPie.vue?vue&type=script&lang=js"
export * from "./NestedPie.vue?vue&type=script&lang=js"

import "./NestedPie.vue?vue&type=style&index=0&id=61273c46&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61273c46"]])

export default __exports__